import { useState, useEffect, useContext } from 'react';
import { Typography } from '@mui/material';

import SmartForm from '@component/smartForm/SmartForm';
import SmartTextInput from '@component/smartForm/SmartInputText';
import SmartTextareaInput from './smartForm/SmartTextareaInput';
import SmartImageUpload from './smartForm/SmartImageUpload';
import SmartContainer from './smartForm/SmartContainer';

import { useTranslation } from "react-i18next";

import { useQueryClient } from "@tanstack/react-query";
import { useSiteUpdateMutation } from '@mutation/siteMutation';
import { AlertContext } from "@context/AlertProvider";

const SiteForm = ({
  site
}) => {
  const queryClient = useQueryClient();
  const siteUpdateMutation = useSiteUpdateMutation(site?.uuid);
  const [formModel, setFormModel] = useState(site);
  const { addAlertBanner } = useContext(AlertContext);
  const { t } = useTranslation(["main", "error"]);

  useEffect(()=>{
    setFormModel(site)
  },[site])

  const handleSave = (newModel) => {
    siteUpdateMutation.mutate(
      { data: { file_image_uuid: newModel.file_image.uuid, ...newModel } },
      {
        onSuccess: () => {
            addAlertBanner(t("main:saveSuccess"), "success", 4000);
            queryClient.invalidateQueries({ queryKey: ["site"] });
        },
        onError: (error) => {
            if (!error.response) {
                addAlertBanner(t("error:networkError"), "error", 4000);
                return;
            }
      
            const statusCode = error.response.status;
      
            if (statusCode === 403) {
            addAlertBanner(t("error:noModificationPrivileges"), "error", 5000);
            } else if (statusCode === 404) {
            addAlertBanner(t("error:notFound"), "error", 4000);
            } else if (statusCode === 400) {
            addAlertBanner(t("error:validationError"), "error", 5000);
            } else if (statusCode === 422) {
            addAlertBanner(t("error:validationError"), "error", 5000);
            } else if (statusCode >= 500) {
            addAlertBanner(t("error:serverError"), "error", 4000);
            } else {
            addAlertBanner(t("error:somethingGoesWrong"), "error", 4000);
            }
        }
      }
    );
  };

  return (
    <SmartForm
      // model={site}
      formModel={formModel}
      setFormModel={setFormModel}
      onSave={handleSave}
      buttonPanelSx={{
          top: "10px",
          right: "10px",
          zIndex: "drawer" // beacuse of sidebar
      }}
    >
      <SmartImageUpload field="file_image.uuid" />

      <SmartTextInput 
        field="name" 
        label="Site Name"
        renderView={(value) => (
          <Typography variant="h3" align="center" sx={{ fontWeight: 500 }}>
            {value || 'Untitled Club'}
          </Typography>
        )}
      />
      
      <SmartTextareaInput field="description" label="Description" rows={10} />

      <SmartContainer 
        contentSx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
          gap: 2,
          '& > *': {
            minWidth: 0
          }
        }}
      >
        <SmartTextInput field="adr_street" label="Street" />
        <SmartTextInput field="adr_unit" label="Unit" />
        <SmartTextInput field="adr_state_or_region" label="State" />
        <SmartTextInput field="adr_sub_region" label="Region" />
        <SmartTextInput field="adr_country_code" label="Country Code" />
        <SmartTextInput field="adr_postcode_or_zip" label="Zip" />
      </SmartContainer>

    </SmartForm>
  );
};

export default SiteForm;